/**
 * TanStack Query hooks for `real-time-conversion-notifications`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	realTimeConversionNotificationsQueryKeys,
	type CreateRealTimeConversionNotificationsBody,
	type ListRealTimeConversionNotificationsResponse,
	type RealTimeConversionNotificationsRow,
} from "./api";

export function useRealTimeConversionNotificationsList(): UseQueryResult<ListRealTimeConversionNotificationsResponse, Error> {
	return useQuery({
		queryKey: realTimeConversionNotificationsQueryKeys.list(),
		queryFn: list,
	});
}

export function useRealTimeConversionNotificationsCreate(): UseMutationResult<RealTimeConversionNotificationsRow, Error, CreateRealTimeConversionNotificationsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: realTimeConversionNotificationsQueryKeys.all });
		},
	});
}

export function useRealTimeConversionNotificationsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: realTimeConversionNotificationsQueryKeys.all });
		},
	});
}
